import { render, staticRenderFns } from "./CallTime.vue?vue&type=template&id=270ae96d&scoped=true"
import script from "./CallTime.vue?vue&type=script&lang=js"
export * from "./CallTime.vue?vue&type=script&lang=js"
import style0 from "./CallTime.vue?vue&type=style&index=0&id=270ae96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ae96d",
  null
  
)

export default component.exports